import React from 'react';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
}

const sizeClasses = {
  sm: 'h-7 w-7',
  md: 'h-11 w-11',
  lg: 'h-16 w-16',
  xl: 'h-20 w-20'
};

const textSizeClasses = {
  sm: 'text-lg',
  md: 'text-2xl',
  lg: 'text-3xl',
  xl: 'text-4xl'
};

const subtextSizeClasses = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-base',
  xl: 'text-lg'
};

const LogoVariant: React.FC<LogoProps> = ({ className = '', size = 'md', showText = true }) => (
  <div className={`flex items-center space-x-3 ${className}`}>
    <div className={`${sizeClasses[size]} relative`}>
      <img src="/logo.png" alt="ClinLexis" className="w-full h-full object-contain" />
    </div>
    {showText && (
      <div className="flex flex-col">
        <span className={`font-bold text-medical-900 ${textSizeClasses[size]} leading-tight tracking-tight`}>
          ClinLexis
        </span>
        {size !== 'sm' && (
          <span className={`${subtextSizeClasses[size]} text-primary-600 font-medium -mt-0.5`}>
            Med-Legal Intelligence
          </span>
        )}
      </div>
    )}
  </div>
);

export const LogoOption1 = LogoVariant;
export const LogoOption2 = LogoVariant;
export const LogoOption3 = LogoVariant;
export const LogoOption4 = LogoVariant;
export const LogoOption5 = LogoVariant;
